module.exports = __webpack_public_path__ + "img/IconMakerPicture1.bed601b6.jpg";